import { Backdrop, Box, Button, Divider, Fade, Grid, Modal, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { GetCertificadoRework } from "../../../../../hooks/getEncuesta";
import { useLoading } from "../../../../../components/Loading/useLoading";
import { PreguntaResponse } from "./preguntaResponse";
import { useSnackbar } from "notistack";
import moment from "moment";
import { CreateCuestionariosRespuestasRework } from "../../../../../hooks/cuestionarios";

export const ModalCertificadoResponse = ({ open, setOpen, id_cues, keepMounted = false, }) => {

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    maxWidth: 1000,
    minWidth: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    pt: 3,
    display: "flex",
    justifyContent: "center",
    maxHeight: 550,
  };

  const formCert = useRef(null);
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { getCertificadoReworkMutation } = GetCertificadoRework();
  const { createCuestionariosRespuestasReworkMutation } = CreateCuestionariosRespuestasRework();
  const [encuesta, setEncuesta] = useState(null);
  const [secciones, setSecciones] = useState([]);
  const [preguntas, setPreguntas] = useState([]);


  const getEncuesta = async () => {
    setAppLoading(true);
    getCertificadoReworkMutation(id_cues, {
      onSuccess: (data) => {
        setEncuesta(data.data.cuestionario);
        let secc = data.data.secciones;
        secc.map(s => {
          s.cuestionarios_preguntas.map(p => {
            p.respuesta = null
          })
        })
        setSecciones(secc);
        let preg = data.data.preguntas;
        preg.map(p => {
          p.respuesta = null
        })
        setPreguntas(preg);
      },
      onError: () => { setEncuesta(null) },
      onSettled: () => { setAppLoading(false) }
    })
  }
  const saveResponses = async (responses) => {
    setAppLoading(true);
    createCuestionariosRespuestasReworkMutation(responses, {
      onSuccess: (data) => {
        console.log("data", data);
        enqueueSnackbar("Respuestas guardadas con exito", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: () => {
        enqueueSnackbar("Error al guardar las respuestas, favor de intentar nuevamente", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
        handleClose();
      }
    })
  }

  useEffect(() => {
    if (id_cues !== null && open) {
      getEncuesta();
    }
  }, [open]);

  const changeDataPregunta = (indexSeccion, indexPregunta, field, value) => {
    if (indexSeccion === null) {
      let preguntasTemp = [...preguntas];
      preguntasTemp[indexPregunta][field] = value;
      setPreguntas(preguntasTemp);
    } else {
      let seccionesTemp = [...secciones];
      seccionesTemp[indexSeccion].cuestionarios_preguntas[indexPregunta][field] = value;
      setSecciones(seccionesTemp);
    }
  }

  const validateSecciones = () => {
    if (secciones.length > 0) {
      let exist_null = secciones.some(seccion => {
        return seccion.cuestionarios_preguntas.some((preg) => {
          return preg.cupe_valorprellenado === null && preg.respuesta === null;
        })
      })
      return exist_null;
    }
    return false;
  }
  const validatePreguntas = () => {
    if (preguntas.length > 0) {
      let exist_null = preguntas.some((preg) => {
        return preg.cupe_valorprellenado === null && preg.respuesta === null;
      })
      return exist_null;
    }
    return false;
  }

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("secciones", secciones);
    let validate_secciones = validateSecciones();
    let validate_preguntas = validatePreguntas();
    if (validate_secciones || validate_preguntas) {
      enqueueSnackbar("Por favor, complete todas las preguntas obligatorias.", {
        autoHideDuration: 2000,
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
      return false;
    } else {
      let resSecc = secciones.map(seccion => seccion.cuestionarios_preguntas)
      resSecc = resSecc.flat();
      let responses = [...resSecc, ...preguntas].map(pregunta => {
        let cure_respuesta = pregunta.cupe_tipo === 4 ? JSON.stringify(pregunta.respuesta) : pregunta.respuesta || pregunta.cupe_valorprellenado;
        return {
          cure_respuesta,
          cure_pregunta: pregunta.cupe_pregunta,
          cure_descripcion: pregunta.cupe_descripcion,
          cure_tipopregunta: pregunta.cupe_tipo,
          cure_multiple: pregunta.cupe_multiple,
          cure_opciones: pregunta.cupe_opciones,
          cues_id: encuesta.cues_id,
          stand_id: pregunta.stand_id
        }
      })
      saveResponses(responses);
    }
  }


  const handleClose = () => {
    setEncuesta(null);
    setSecciones([]);
    setPreguntas([]);
    formCert.current.reset();
    setOpen(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={keepMounted}
      hideBackdrop={keepMounted}
      sx={{ zIndex: 4000 }}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          {encuesta !== null && open ? (
            <form
              ref={formCert}
              onSubmit={onSubmit}
              style={{ overflowY: "scroll", height: "500px", width: "100%" }}
            >
              <Grid container spacing={0}>
                <Grid item xs={12} sx={{ p: 0, textAlign: "center" }}>
                  <Typography
                    id="transition-modal-title"
                    variant="h5"
                    component="h4"
                  >
                    {encuesta?.cues_nombre?.toUpperCase()}
                  </Typography>
                </Grid>
                <Grid item xs={12} sx={{ p: 0, pl: 2, pr: 2, textAlign: "justify", mb: 3, mt: 2, }}>
                  <Typography
                    id="transition-modal-title"
                    variant="h8"
                    component="h4"
                  >
                    {encuesta?.cues_descripcion}
                  </Typography>
                </Grid>
                {encuesta?.cues_observaciones && (
                  <Grid item xs={12} sx={{ p: 0, pl: 2, pr: 2, textAlign: "justify", mb: 3, mt: 2, }} >
                    <Typography
                      id="transition-modal-title"
                      variant="h10"
                      component="h8"
                    >
                      {encuesta?.cues_observaciones}
                    </Typography>
                  </Grid>
                )}
                {
                  secciones.map((seccion, index) => (
                    <>
                      <Grid item xs={12} sx={{ p: 0, textAlign: "center" }}>
                        <Typography
                          id="transition-modal-title"
                          variant="h6"
                          component="h4"
                        >
                          {seccion?.cuse_nombre?.toUpperCase()}
                        </Typography>
                      </Grid>
                      <Divider sx={{ mt: 2, mb: 3 }} />
                      {
                        seccion.cuestionarios_preguntas.map((pregunta, index_p) => (
                          <PreguntaResponse
                            key={`s${index}_p${index_p}`}
                            pregunta={pregunta}
                            formdata={formCert}
                            seccion_index={index}
                            pregunta_index={index_p}
                            changeDataPregunta={changeDataPregunta}
                          />
                        ))
                      }
                    </>
                  ))
                }
                {
                  preguntas.map((pregunta, index_p) => (
                    <PreguntaResponse
                      key={`ss_p${index_p}`}
                      pregunta={pregunta}
                      formdata={formCert}
                      seccion_index={null}
                      pregunta_index={index_p}
                      changeDataPregunta={changeDataPregunta}
                    />
                  ))
                }
              </Grid>
              {
                keepMounted && (
                  <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                    <Button variant="contained"
                      className="btn_system"
                      type="submit"
                    >
                      Guardar
                    </Button>
                  </Grid>
                )
              }
            </form>
          ) : (
            <p>No se pudo cargar el check de línea, favor de refrescar</p>
          )}
        </Box>
      </Fade>
    </Modal>
  )
}